
export default {
  name: 'UIDonutSvg',
  props: {
    series: {
      type: Array,
      required: true,
    },
    colors: {
      type: Array,
      default: () => [],
    },
    width: {
      type: Number,
      default: 64,
    },
    height: {
      type: Number,
      default: 64,
    },
    strokeWidth: {
      type: Number,
      default: 12,
    },
    animated: {
      type: Boolean,
      default: false,
    },
    animationDurationMs: {
      type: Number,
      default: 900,
    },
    maskColor: {
      type: String,
      default: '#ffffff',
    },
  },
  data() {
    return {
      hasStartedAnimation: false,
    };
  },
  computed: {
    sanitizedSeries() {
      return this.series.map((value) => {
        const numericValue = Number(value);
        return Number.isFinite(numericValue) && numericValue > 0
          ? numericValue
          : 0;
      });
    },

    centerX() {
      return this.width / 2;
    },

    centerY() {
      return this.height / 2;
    },

    radius() {
      const minDimension = Math.min(this.width, this.height);
      return Math.max((minDimension - this.strokeWidth) / 2, 0);
    },

    circumference() {
      return 2 * Math.PI * this.radius;
    },

    segments() {
      if (!this.sanitizedSeries.length || this.circumference <= 0) {
        return [];
      }

      let accumulatedPercent = 0;

      return this.sanitizedSeries.map((percent, index) => {
        const segmentLength = (percent / 100) * this.circumference;
        const gapLength = Math.max(this.circumference - segmentLength, 0);
        const dashOffset = -((accumulatedPercent / 100) * this.circumference);

        accumulatedPercent += percent;

        return {
          color: this.colors[index % this.colors.length] || '#000000',
          dashArray: `${segmentLength} ${gapLength}`,
          dashOffset,
        };
      });
    },

    maskDashoffset() {
      if (!this.animated) {
        return -this.circumference;
      }

      return this.hasStartedAnimation ? -this.circumference : 0;
    },

    maskStyle() {
      return {
        transition: `stroke-dashoffset ${this.animationDurationMs}ms ease-out`,
      };
    },
  },
  mounted() {
    if (!this.animated) {
      return;
    }

    requestAnimationFrame(() => {
      this.hasStartedAnimation = true;
    });
  },
};
